import { withTranslation } from "react-i18next";
// import { useEffect, useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   Alert,
//   Button,
//   Card,
//   CardBody,
//   Col,
//   Input,
//   Modal,
//   ModalBody,
//   ModalHeader,
//   Nav,
//   NavItem,
//   NavLink,
//   Row
// } from "reactstrap";
// import Paginations from "../../../components/Common/Pagination";
import UpskillingPageHero from "../../../components/Upskilling/PageHero";
// import UpskillingEmptyStateHero from "../../../components/Upskilling/EmptyStateHero";
// import UpskillingListSkeleton from "../../../components/Upskilling/ListSkeleton";
// import UpskillingStatusBadge from "../../../components/Upskilling/StatusBadge";
// import { useDebounce } from "../../../hooks/useDebounce";
// import {
//   extractUpskillingRows,
//   extractUpskillingTotal,
//   getCertificationProofUrl,
//   getRowCourseName,
//   getRowSlug,
//   normalizeUpskillingStatus,
//   useUpskillingListQuery
// } from "../../../api/upskilling";
// import {
//   extractCourseCatalogTotal,
//   extractCourseRows,
//   getCourseProviders,
//   getCourseSlug,
//   getCourseTitle,
//   summarizeCertificatesAndRoles,
//   useUpskillingCoursesCatalogQuery
// } from "../../../api/upskillingCourses";

/*
const STATUS_TABS = [
  { id: "all", label: "All" },
  { id: "inprogress", label: "In Progress" },
  { id: "rejected", label: "Rejected" },
  { id: "completed", label: "Completed" },
];

const DURATION_OPTIONS = [
  { value: "all", label: "Any duration" },
  { value: "3", label: "3 months" },
  { value: "6", label: "6 months" },
  { value: "12", label: "12 months" },
];
*/

const UPSKILLING_NETWORK_MESSAGE_KEYS = [
  "upskillingNetworkMessage1",
  "upskillingNetworkMessage2",
];

function UpskillingListPage({ t }) {
  document.title = t("upskillingPageTitle", "Upskilling | Worker");

  // const [page, setPage] = useState(1);
  // const [limit] = useState(12);
  // const [searchInput, setSearchInput] = useState("");
  // const debouncedSearch = useDebounce(searchInput, 400);
  // const [providersModal, setProvidersModal] = useState(null);
  // const [statusTab, setStatusTab] = useState("all");
  // const [durationFilter, setDurationFilter] = useState("all");

  // const catalogParams = useMemo(
  //   () => ({
  //     page,
  //     limit,
  //     courseSlugs: []
  //   }),
  //   [page, limit]
  // );

  // const { data, isPending, isError, error, refetch, isFetching } =
  //   useUpskillingCoursesCatalogQuery(catalogParams);

  /*
  const listParams = useMemo(
    () => ({
      page,
      limit,
      duration: durationFilter,
      status: statusTab,
      search: debouncedSearch.trim(),
    }),
    [page, limit, durationFilter, statusTab, debouncedSearch]
  );

  const { data, isPending, isError, error, refetch, isFetching } =
    useUpskillingListQuery(listParams);

  const rows = extractUpskillingRows(data);
  const total = extractUpskillingTotal(data);
  */

  // const allRows = extractCourseRows(data);
  // const rows = useMemo(() => {
  //   const q = debouncedSearch.trim().toLowerCase();
  //   if (!q) return allRows;
  //   return allRows.filter((course) =>
  //     getCourseTitle(course).toLowerCase().includes(q)
  //   );
  // }, [allRows, debouncedSearch]);

  // const total = extractCourseCatalogTotal(data);
  // const empty = !isPending && rows.length === 0;

  // useEffect(() => {
  //   setPage(1);
  // }, [debouncedSearch]);

  // const closeProvidersModal = () => setProvidersModal(null);

  /*
  useEffect(() => {
    setPage(1);
  }, [statusTab, durationFilter, debouncedSearch]);

  const isDefaultFilters =
    statusTab === "all" &&
    durationFilter === "all" &&
    debouncedSearch.trim() === "";
  const showHeroBanner = empty && isDefaultFilters;
  */

  // const formatProviderCount = (count) =>
  //   count === 1
  //     ? t("upskillingProviderSingular", { count, defaultValue: "{{count}} provider" })
  //     : t("upskillingProviderPlural", { count, defaultValue: "{{count}} providers" });

  // const formatCertCount = (count) =>
  //   count === 1
  //     ? t("upskillingCertSingular", { count, defaultValue: "{{count}} cert" })
  //     : t("upskillingCertPlural", { count, defaultValue: "{{count}} certs" });

  return (
    <div className="page-content">
      <div className="container-fluid">
        <UpskillingPageHero />

        <div className="upskilling-network-message">
          {UPSKILLING_NETWORK_MESSAGE_KEYS.map((key) => (
            <p key={key} className="upskilling-network-message__text">
              {t(
                key,
                key === "upskillingNetworkMessage1"
                  ? "We're currently developing our Upskilling Network."
                  : "Before introducing training providers to the platform, we're working to establish trusted partnerships that deliver value for both our workers and our partners. This ensures that any training or qualifications promoted through JobArk are relevant, recognised and aligned with genuine employment opportunities."
              )}
            </p>
          ))}
        </div>

        {/*
        <Row className="mb-3 align-items-center">
          <Col>
            <Nav className="nav-pills flex-wrap gap-1">
              {STATUS_TABS.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink
                    href="#"
                    className={statusTab === tab.id ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setStatusTab(tab.id);
                    }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Col>
          <Col xs="auto" className="mt-2 mt-md-0">
            <Link to="/upskilling/new" className="btn btn-primary">
              New Upskilling
            </Link>
          </Col>
        </Row>

        {showHeroBanner ? <UpskillingEmptyStateHero /> : null}

        <Row className="mb-3 g-2 align-items-end">
          <Col md={4}>
            <label className="form-label mb-1 text-muted small">
              {t("upskillingSearchLabel", "Search by course")}
            </label>
            <Input
              type="search"
              placeholder={t("upskillingSearchPlaceholder", "Course name…")}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <label className="form-label mb-1 text-muted small">Duration</label>
            <Input
              type="select"
              value={durationFilter}
              onChange={(e) => setDurationFilter(e.target.value)}
            >
              {DURATION_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </Input>
          </Col>
        </Row>

        {isError ? (
          <Alert color="danger" className="mb-3">
            {error?.message || t("upskillingLoadError", "Could not load courses.")}{" "}
            <Button
              color="link"
              className="p-0 align-baseline"
              onClick={() => refetch()}
            >
              {t("upskillingRetry", "Retry")}
            </Button>
          </Alert>
        ) : null}

        {isPending ? (
          <UpskillingListSkeleton rows={4} />
        ) : empty ? (
          <Card>
            <CardBody className="text-center text-muted py-5">
              {t("upskillingEmptySearch", "No courses match your search.")}
            </CardBody>
          </Card>
        ) : (
          <div className="position-relative">
            {isFetching && !isPending ? (
              <div className="position-absolute top-0 end-0 p-2 small text-muted">
                <i className="bx bx-loader-alt bx-spin me-1" />
                {t("upskillingUpdating", "Updating…")}
              </div>
            ) : null}
            <Row className="g-3 upskilling-course-grid">
              {rows.map((course) => {
                const slug = getCourseSlug(course);
                const title = getCourseTitle(course);
                const { certificates, roleTitles } =
                  summarizeCertificatesAndRoles(course);
                const certTitles = certificates
                  .map((c) => String(c?.title || "").trim())
                  .filter((certTitle) => certTitle.length > 0);
                const providers = getCourseProviders(course);
                const description =
                  typeof course?.description === "string"
                    ? course.description.trim()
                    : "";

                return (
                  <Col key={slug || title} md={6} lg={4}>
                    <Card className="upskilling-course-card h-100">
                      <CardBody className="p-4 d-flex flex-column">
                        <div className="upskilling-course-card__header mb-3">
                          <h5 className="upskilling-course-card__title">
                            {title}
                          </h5>
                          {certificates.length > 0 ? (
                            <span className="upskilling-course-card__badge">
                              {formatCertCount(certificates.length)}
                            </span>
                          ) : null}
                        </div>

                        {description ? (
                          <p className="upskilling-course-card__description mb-3">
                            {description}
                          </p>
                        ) : null}

                        <div className="upskilling-course-card__section mb-0">
                          <div className="upskilling-course-card__label">
                            {t("upskillingCertificates", "Certificates")}
                          </div>
                          <p className="upskilling-course-card__value upskilling-course-card__value--clamp">
                            {certTitles.length > 0
                              ? certTitles.join(", ")
                              : t("upskillingNoCertificates", "No certificates listed.")}
                          </p>
                        </div>

                        <div className="upskilling-course-card__section">
                          <div className="upskilling-course-card__label">
                            {t("upskillingValidForRoles", "Valid for roles")}
                          </div>
                          <p className="upskilling-course-card__value upskilling-course-card__value--clamp">
                            {roleTitles.length > 0
                              ? roleTitles.join(", ")
                              : "—"}
                          </p>
                        </div>

                        <div className="upskilling-course-card__footer mt-auto">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="min-w-0">
                              <div className="upskilling-course-card__label mb-1">
                                {t("upskillingTrainingProviders", "Training providers")}
                              </div>
                              <p className="upskilling-course-card__meta mb-0">
                                {providers.length === 0
                                  ? t("upskillingNoneListed", "None listed")
                                  : formatProviderCount(providers.length)}
                              </p>
                            </div>
                            {providers.length > 0 ? (
                              <Button
                                color="secondary"
                                outline
                                size="sm"
                                className="flex-shrink-0"
                                onClick={() =>
                                  setProvidersModal({ title, providers })
                                }
                              >
                                {t("upskillingView", "View")}
                              </Button>
                            ) : null}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}

        {isFetching ? (
          <UpskillingListSkeleton />
        ) : empty && showHeroBanner ? null : empty ? (
          <Card>
            <CardBody className="text-center text-muted py-5">
              No records match your filters.
            </CardBody>
          </Card>
        ) : (
          <div className="position-relative">
            {isFetching && !isPending ? (
              <div className="position-absolute top-0 end-0 p-2 small text-muted">
                <i className="bx bx-loader-alt bx-spin me-1" />
                Updating…
              </div>
            ) : null}
            <div className="d-flex flex-column gap-3">
              {rows.map((row) => {
                const slug = getRowSlug(row);
                const name = getRowCourseName(row);
                const status = row.status || row.upskillingStatus;
                const norm = normalizeUpskillingStatus(status);
                const proof = getCertificationProofUrl(row);
                const isOptimistic =
                  row._optimistic || String(slug).startsWith("optimistic-");
                const showUpload =
                  !isOptimistic && norm === "inprogress" && !proof && slug;

                return (
                  <Card
                    key={slug || `${name}-${status}`}
                    className="mb-0 shadow-sm"
                  >
                    <CardBody>
                      <Row className="align-items-center gy-2">
                        <Col md>
                          <div className="fw-semibold fs-16 mb-1">{name}</div>
                          <div className="text-muted small">
                            {row.courseSlug || row.course?.slug
                              ? `Slug: ${row.courseSlug || row.course?.slug}`
                              : null}
                          </div>
                        </Col>
                        <Col xs="auto">
                          <UpskillingStatusBadge status={status} />
                        </Col>
                        <Col
                          xs="auto"
                          className="d-flex flex-wrap gap-2 justify-content-end"
                        >
                          {slug && !isOptimistic ? (
                            <Link
                              to={`/upskilling/${slug}`}
                              className="btn btn-sm btn-soft-info"
                            >
                              View
                            </Link>
                          ) : null}
                          {showUpload ? (
                            <Link
                              to={`/upskilling/${slug}?upload=1`}
                              className="btn btn-sm btn-outline-primary"
                            >
                              Upload
                            </Link>
                          ) : null}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                );
              })}
            </div>
          </div>
        )}

        {!isPending && total > 0 ? (
          <Row className="mt-3">
            <Col>
              <Paginations
                total={total}
                perPageData={limit}
                currentPage={page}
                setCurrentPage={setPage}
                isShowingPageLength
                paginationDiv="col-auto ms-auto"
                paginationClass="pagination pagination-rounded justify-content-end mb-0"
              />
            </Col>
          </Row>
        ) : null}

        <Modal
          isOpen={!!providersModal}
          toggle={closeProvidersModal}
          centered
          size="md"
        >
          <ModalHeader toggle={closeProvidersModal}>
            {t("upskillingTrainingProviders", "Training providers")}
          </ModalHeader>
          <ModalBody>
            {providersModal?.title ? (
              <p className="text-muted small mb-3">{providersModal.title}</p>
            ) : null}
            {providersModal?.providers?.length ? (
              <ul className="upskilling-providers-modal__list mb-0">
                {providersModal.providers.map((provider, index) => (
                  <li key={`modal-provider-${index}`}>
                    {provider.description ? (
                      <div className="fw-medium mb-1">{provider.description}</div>
                    ) : null}
                    <a
                      href={provider.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {provider.link}
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted mb-0">
                {t(
                  "upskillingModalNoProviders",
                  "No training providers are listed for this course yet."
                )}
              </p>
            )}
          </ModalBody>
        </Modal>
        */}
      </div>
    </div>
  );
}

export default withTranslation()(UpskillingListPage);
